'use strict';

var _rollupPluginBabelHelpers = require('../../../_virtual/_rollupPluginBabelHelpers.js');
var React = require('react');
var PropTypes = require('prop-types');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);
var PropTypes__default = /*#__PURE__*/_interopDefaultLegacy(PropTypes);

var Switch = function Switch(_ref) {
  var className = _ref.className,
      name = _ref.name,
      checked = _ref.checked,
      disabled = _ref.disabled,
      onChange = _ref.onChange,
      id = _ref.id;

  var _useState = React.useState(checked),
      _useState2 = _rollupPluginBabelHelpers.slicedToArray(_useState, 2),
      isChecked = _useState2[0],
      setIsChecked = _useState2[1];

  var handleChange = function handleChange(e) {
    setIsChecked(e.target.checked);
    onChange(e.target.checked);
  };

  React.useEffect(function () {
    setIsChecked(checked);
  }, [checked]);
  return /*#__PURE__*/React__default['default'].createElement("label", {
    htmlFor: id,
    className: "ds-atom-switch rounded ".concat(className, " ").concat(isChecked ? 'selected' : '')
  }, /*#__PURE__*/React__default['default'].createElement("input", {
    id: id,
    type: "checkbox",
    className: "hidden",
    checked: isChecked ? 'checked' : '',
    disabled: disabled,
    name: name,
    onChange: handleChange
  }), /*#__PURE__*/React__default['default'].createElement("span", {
    className: "ds-atom-switch-slider rounded"
  }));
};

Switch.propTypes = {
  className: PropTypes__default['default'].string,
  name: PropTypes__default['default'].string,
  checked: PropTypes__default['default'].bool,
  disabled: PropTypes__default['default'].bool,
  onChange: PropTypes__default['default'].func,
  id: PropTypes__default['default'].string
};
Switch.defaultProps = {
  className: '',
  name: '',
  checked: false,
  disabled: false,
  onChange: function onChange() {},
  id: 'switch'
};
var index = React.memo(Switch);

module.exports = index;
